import React from 'react';
import Badge from '../ui/Badge';
import { formatShortDate } from '../../utils/date-utils';

export default function StatusHistory({ statusHistory = [] }) {
  if (!statusHistory || statusHistory.length === 0) {
    return (
      <div style={{
        padding: '16px',
        textAlign: 'center',
        color: '#999',
        fontSize: '13px'
      }}>
        No status history available
      </div>
    );
  }

  // Sort by timestamp (newest first)
  const sorted = [...statusHistory].sort((a, b) => {
    const dateA = a.timestamp ? new Date(a.timestamp) : new Date(0);
    const dateB = b.timestamp ? new Date(b.timestamp) : new Date(0);
    return dateB - dateA;
  });

  return (
    <div>
      <h3 style={{
        fontSize: '16px',
        fontWeight: '600',
        color: '#2b2b2b',
        marginBottom: '16px'
      }}>
        Status History
      </h3>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
      }}>
        {sorted.map((entry, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              gap: '12px',
              padding: '12px',
              background: index === 0 ? 'rgba(139, 69, 19, 0.05)' : 'rgba(0, 0, 0, 0.02)',
              borderRadius: '8px',
              borderLeft: index === 0 ? '3px solid #8B4513' : '3px solid #e5e5e5'
            }}
          >
            {/* Timeline Dot */}
            <div style={{
              minWidth: '32px',
              display: 'flex',
              alignItems: 'flex-start',
              paddingTop: '4px'
            }}>
              <div style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                background: index === 0 ? '#8B4513' : '#d1d5db',
                border: '2px solid white',
                boxShadow: '0 0 0 2px #e5e5e5'
              }} />
            </div>

            {/* Content */}
            <div style={{ flex: 1 }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '4px'
              }}>
                <Badge status={entry.status}>
                  {entry.status}
                </Badge>
                
                {index === 0 && (
                  <span style={{
                    fontSize: '11px',
                    fontWeight: '600',
                    color: '#8B4513',
                    padding: '2px 6px',
                    background: 'rgba(139, 69, 19, 0.1)',
                    borderRadius: '4px'
                  }}>
                    Current
                  </span>
                )}
              </div>

              <div style={{
                fontSize: '13px',
                color: '#666',
                marginBottom: '4px'
              }}>
                {entry.timestamp && formatShortDate(entry.timestamp)}
              </div>

              {entry.note && (
                <div style={{
                  fontSize: '13px',
                  color: '#2b2b2b',
                  fontStyle: 'italic'
                }}>
                  "{entry.note}"
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}